import { render, staticRenderFns } from "./faturaentegrasyon.vue?vue&type=template&id=1a3c21f4&"
import script from "./faturaentegrasyon.vue?vue&type=script&lang=js&"
export * from "./faturaentegrasyon.vue?vue&type=script&lang=js&"
import style0 from "./faturaentegrasyon.vue?vue&type=style&index=0&id=1a3c21f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports